import script from "./BeneficiariesView.vue?vue&type=script&setup=true&lang=js"
export * from "./BeneficiariesView.vue?vue&type=script&setup=true&lang=js"

import "./BeneficiariesView.vue?vue&type=style&index=0&id=66878704&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-66878704"]])

export default __exports__